import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Event {
    id: string;
    festId: string;
    name: string;
    code: string;
    type: string;
    category?: string;
    maxParticipants: number;
    maxParticipantsPerTeam?: number;
    duration?: number;
    scoringMethod: string;
    status: string;
    fest?: { name: string };
}

interface EventState {
    events: Event[];
    loading: boolean;
    error: string | null;
}

const initialState: EventState = {
    events: [],
    loading: false,
    error: null,
};

const eventSlice = createSlice({
    name: 'Event',
    initialState,
    reducers: {
        setEvents: (state, action: PayloadAction<Event[]>) => {
            state.events = action.payload;
            state.loading = false;
            state.error = null;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
            state.loading = false;
        },
        addEvent: (state, action: PayloadAction<Event>) => {
            state.events.unshift(action.payload);
        },
        updateEventInList: (state, action: PayloadAction<Event>) => {
            const index = state.events.findIndex((e) => e.id === action.payload.id);
            if (index !== -1) {
                state.events[index] = action.payload;
            }
        },
        removeEventFromList: (state, action: PayloadAction<string>) => {
            state.events = state.events.filter((e) => e.id !== action.payload);
        },
    },
});

export const {
    setEvents,
    setLoading,
    setError,
    addEvent,
    updateEventInList,
    removeEventFromList,
} = eventSlice.actions;
export default eventSlice.reducer;
